import { useState } from 'react';
import { breakpoints, Column, Columns, Input, Stack } from '@etg/wings';
import { getInputMaskConfig, MaskedInput } from '@eti/components';
import { constants, date, persistInputData, string } from '@eti/utils';
import { useProperty, useSnowplowTracking, useTranslation, useValidation } from '@eti/providers';
import { Field as ReduxFormField } from 'redux-form';
import { AgeType } from '@eti/schema-types';
import { DATE_OF_BIRTH } from '../../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  DATE_PATTERN
} = constants.inputFieldPatterns;
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const MaskedDateInput = _ref => {
  let {
    dateFormat,
    id,
    input,
    isReadOnly,
    meta,
    name,
    shouldMarkInputAsRequired,
    ...props
  } = _ref;
  const {
    t,
    nonDebugT
  } = useTranslation();
  const hasError = Boolean(meta.invalid && !meta.active && (input.value !== '' || meta.touched));
  const errorId = hasError ? `${name}-error` : undefined;
  const label = t('TravelerForm.DateOfBirth.Label');
  const resolvedLabel = shouldMarkInputAsRequired ? nonDebugT('Input.Field.Required', label) : label;
  const descriptionId = `${name}-description`;
  const description = string.insertArgument(t('TravelerForm.DateOfBirth.HintLabel'), dateFormat.toUpperCase());
  const {
    mask,
    pipe
  } = getInputMaskConfig(date.getBirthDateConstraints(new Date()), dateFormat);
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 4,
    children: [/*#__PURE__*/_jsx(Input.Label, {
      htmlFor: name,
      children: resolvedLabel
    }), /*#__PURE__*/_jsx(MaskedInput, {
      autoCorrect: "off",
      className: MOUSE_FLOW_CLASS_NAMES,
      "data-testid": `traveler-date-of-birth-form-${id}-input`,
      descriptionId: descriptionId,
      errorId: errorId,
      hasError: hasError,
      id: name,
      inputMode: "numeric",
      isReadOnly: isReadOnly,
      mask: mask,
      pattern: DATE_PATTERN,
      pipe: pipe,
      placeholder: dateFormat.toUpperCase(),
      required: Boolean(shouldMarkInputAsRequired),
      spellCheck: "false",
      ...input,
      ...props
    }), /*#__PURE__*/_jsx(Input.Meta, {
      description: description,
      descriptionId: descriptionId,
      error: meta.error,
      errorId: errorId,
      hasError: hasError
    })]
  });
};
const DateOfBirth = _ref2 => {
  let {
    ageType = AgeType.Adt,
    dateFormat = 'yyyy-MM-dd',
    form,
    id,
    isReadOnly,
    onBlur
  } = _ref2;
  const {
    p
  } = useProperty();
  const {
    isSnowplowTrackingEnabled,
    sendTrackEvent
  } = useSnowplowTracking();
  const [snowplowHasBeenCalled, setSnowplowHasBeenCalled] = useState(false);
  const name = `${DATE_OF_BIRTH}-${id}`;
  const validate = useValidation(`${DATE_OF_BIRTH}-${ageType}`);
  const sendTrackEventID = id ? parseInt(id, 10) + 1 : 0;
  const handleOnBlur = event => {
    if (p('IbeClient.TravelerDetails.PersistFormData.Enabled')) {
      persistInputData(form, `${DATE_OF_BIRTH}-${id}`)(event === null || event === void 0 ? void 0 : event.target.value);
    }
    onBlur(event);
  };
  const handleOnChange = () => {
    if (isSnowplowTrackingEnabled && !snowplowHasBeenCalled) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Date of Birth',
        value: sendTrackEventID
      });
      setSnowplowHasBeenCalled(true);
    }
  };
  return /*#__PURE__*/_jsx(Columns, {
    spacing: 24,
    children: /*#__PURE__*/_jsx(Column, {
      width: {
        [breakpoints._0]: '4/4',
        [breakpoints._560]: '2/4'
      },
      children: /*#__PURE__*/_jsx(ReduxFormField, {
        component: MaskedDateInput,
        dateFormat: dateFormat,
        id: id,
        isReadOnly: isReadOnly,
        name: name,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        props: {
          name
        },
        shouldMarkInputAsRequired: true,
        validate: validate
      })
    })
  });
};
export default DateOfBirth;
//# sourceMappingURL=DateOfBirth.js.map